module.exports = require('./helpers/bundle-url').getBundleURL('jWbtw') + "DAIKLogo.7aa105ad.png";